import { render, staticRenderFns } from "./updataPwd.vue?vue&type=template&id=fa256b04&scoped=true&"
import script from "./updataPwd.vue?vue&type=script&lang=js&"
export * from "./updataPwd.vue?vue&type=script&lang=js&"
import style0 from "./updataPwd.vue?vue&type=style&index=0&id=fa256b04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa256b04",
  null
  
)

export default component.exports